import React, { useState, ReactNode } from "react";
import { tt } from "../../../utils/i18n/i18n";
import { type TranslationsKeys } from "../../../utils/i18n/translations/Translations";
import TwemojiWrapper from "../../../components/TwemojiWrapper/TwemojiWrapper";
import KC_Heading2 from "../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Button from "../../../designsystem/KC_Button/KC_Button";
import AvgBasketModal from "./modals/AvgBasketModal";
import CurrencyProp from "./model/CurrencyProp";
import type ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import "../styles.scss";

interface Props {
  accountToDisplay: ManagedAccount;
  currency: CurrencyProp;
  children: ReactNode;
  messageKey?: keyof TranslationsKeys;
}

export default function AvgBasketPromptOverlay({
  accountToDisplay,
  currency,
  children,
  messageKey = "analytics_no_avg_basket_message"
}: Props) {
  const [isAvgBasketModalOpen, setIsAvgBasketModalOpen] = useState(false);
  const shouldShowAvgBasketPrompt = !accountToDisplay.avgBasket;

  return (
    <>
      <div className={shouldShowAvgBasketPrompt ? "analytics-blurred" : ""}>
        {children}
      </div>

      {shouldShowAvgBasketPrompt && (
        <div className="analytics-overlay d-flex flex-column justify-content-center align-items-center st-gap">
          <TwemojiWrapper isVeryBigText={true}>💰</TwemojiWrapper>
          <KC_Heading2 text={tt(messageKey)} className="text-center" />
          <KC_Button
            text={tt("analytics_no_avg_basket_button")}
            isPrimary={true}
            size="lg"
            onClick={() => setIsAvgBasketModalOpen(true)}
            extraStyle={{
              width: "unset !important"
            }}
          />
        </div>
      )}

      <AvgBasketModal
        isOpen={isAvgBasketModalOpen}
        onClose={() => setIsAvgBasketModalOpen(false)}
        currentAvgBasket={accountToDisplay.avgBasket}
        currency={currency}
      />
    </>
  );
}
